"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_primitive_1 = require("../lang/is-primitive");
var st_1 = require("../st/st");
var change_detector_1 = require("./change-detector");
var change_type_1 = require("./interface/change-type");
var type_function_1 = require("../lang/type-function");
exports.DEFAULT_EMPTY_PATH = "";
var PropChangeManager = /** @class */ (function () {
    function PropChangeManager() {
    }
    PropChangeManager.conditionallyApplyDeepChangeDetection = function (value, onDeepChange) {
        // only activate deep change detection if there is some function to listen to it
        if (!is_primitive_1.isPrimitive(value) && typeof onDeepChange == type_function_1.TYPE_FUNCTION) {
            value = change_detector_1.ChangeDetector.onChange(value, onDeepChange);
        }
        return value;
    };
    PropChangeManager.onChange = function (instance, name, type, onChange, onDeepChange) {
        var value = PropChangeManager.conditionallyApplyDeepChangeDetection(instance[name], onDeepChange);
        Object.defineProperty(instance, name, {
            get: function () { return value; },
            set: function (newValue) {
                var prevValue = value;
                if (type === change_type_1.ChangeType.DEEP) {
                    value = PropChangeManager.conditionallyApplyDeepChangeDetection(newValue, onDeepChange);
                }
                onChange(value, prevValue);
            },
            configurable: true,
        });
        return value;
    };
    return PropChangeManager;
}());
exports.PropChangeManager = PropChangeManager;
if (!st_1.st.onStateChange) {
    st_1.st.onStateChange = PropChangeManager.onChange;
}
//# sourceMappingURL=prop-change-manager.js.map